import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": $options.hasCloseButton,
    "is-visible": $options.isVisible,
    title: $options.modalTitle,
    "is-processing": _ctx.isProcessing,
    onActionClose: $options.close,
    onOpen: $options.onOpen,
    "data-qa": "unauthenticated-follow-modal"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent($options.currentComponent), {
        "return-url": $options.returnUrl,
        onSubmit: $options.onSubmit,
        onClose: $options.close
      }, null, 40 /* PROPS, NEED_HYDRATION */, ["return-url", "onSubmit", "onClose"]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-action-close", "is-visible", "title", "is-processing", "onActionClose", "onOpen"]))
}